import {QCResultData} from './production.type';

export interface ReProductionNumberingRequestParam {
  reProductionId: number;
  securityGrpId: number;
}

export interface ReProductionNumberingResponse {
  minNumberLength: number;
}

export interface SaveReProductionNumberingRequestParam {
  reProductionId: number;
  securityGrpId: number;
  minimumNoLength: number;
  IsMarkComplete: boolean;
}

export interface SaveReProductionNumberingResponse {
  message: string;
}

export interface GetReProductLocationViewRequestParam {
  SecurityGroupId: number;
  reProductionId: number;
  moduleType: string;
}

export interface GetReProductLocationViewResponse {
  moduleType: string;
  productionId: number;
  isMarkComplete: boolean;
  securityGroupId: number;
  reProductionComponentsFolderDetails: ReProductionComponentsFolderDetails;
  reProductionOutputLocation: ReProductionOutputLocation;
  lstReProductionRootPath: ReProductionRootPath[];
  productionStatusCode: string | null;
  volumenLocation: VolumenLocation;
}

export interface ReProductionComponentsFolderDetails {
  folderName_Natives: string | null;
  folderName_Images: string | null;
  folderName_PDF: string | null;
  folderName_LoadFiles: string | null;
  folderName_Text: string | null;
  folderName_Translations: string | null;
  folderName_MP3: string | null;
  toSplitSubFolders: boolean;
  splitCount: number;
}

export interface ReProductionRootPath {
  reProductionRootLabel: string;
  reProductionRootId: number;
}

export interface ReProductionOutputLocation {
  reProductionRootPathID: number;
  reProductionRootPathName: string | null;
  reProductionDirectory: string | null;
  isVolumeIncluded: boolean;
  volumeName: string;
  volumeLocationID: string | null;
  shouldIncludeDrive: boolean;
  driveText: string;
  shouldArchive: boolean;
}

export interface VolumenLocation {
  'In Delivery Folder': string;
  'In Images Folder': string;
  'In All Folders': string;
}

export interface SaveReProductionLocationRequestBody {
  ReProductionId: number;
  IsMarkComplete: boolean;
  ModuleType: string;
  ReProductionOutputLocation: {
    FileServerID: number;
    ReProductionDirectory: string;
    ShouldArchive: boolean;
  };
  SecurityGroupId: number;
}

export interface SaveReProductionLocationResponse {
  message: string;
}
export enum ReProductionTypeCodeEnum {
  ADDREMBRANDING = 0,
  ADDREMREDACTION = 1,
  NATIVETOPLACEHOLDER = 2,
  PLACEHOLDERTONATIVE = 3,
}

export interface SaveReProductionBasicInfoPayload {
  parentSecurityGroupId: number;
  parentReProductionSetID: number;
  reProductionName: string;
  reProductionID: number;
  reProductionDescription?: string;
  disclaimer: string;
  isMarkComplete: boolean;
  isProductionSet: boolean;
  reProductionTypeCode: ReProductionTypeCodeEnum;
}
export interface GetReProductionBasicInfoRequestParam {
  securityGroupId?: number;
  moduleType?: string;
  parentSetId?: number;
  reproductionId?: number;
}
export interface GetReProductionBasicInfoResponse {
  securityGroupId: number;
  parentProductionSetID: number;
  productionName: string;
  productionID: number;
  productionDescription: string;
  disclaimer: string;
  isMarkComplete: boolean;
  isProductionSet: boolean;
  reProductionTypeCode: ReProductionTypeCodeEnum;
}
export interface EditViewReProductionBasicInfoResponse {
  currentStep: number;
  reProductionId?: number;
  productionId?: number;
  securityGroupId: number;
  parentSetID: number;
  productionName: string;
  productionCurrentStatus: number;
  productionStateCode: string;
  ReProductionTypeCode: string;
}
export interface SaveReProductionBasicInfoResponse {
  reProductionID: string;
  message: string;
}

export interface ReProductionResultDetails {
  moduleType: string;
  productionId: number;
  isMarkComplete: boolean;
  productionName: string;
  productionStatus: string;
  productionStatusCode: string;
  productionStateCode: string;
  securityGroupIdForProduction: number;
  numberOfDocumentsGenerated: number;
  numberOfFamilyMembersGenerated: number;
  productionDestinationPath: string;
  qcResultDataList: QCResultData[];
  isFirstCommit: boolean;
  productionDATFilePath: string | null;
  productionArchivePath: string | null;
  shareableLinksExpireOn: string | null;
  nativelyGeneratedDocs: number;
  priorProductionName: string;
}

export interface GetReProductionConfirmViewResponse {
  reProductionResultDetails: ReProductionResultDetails;
  productionCurrentStatus: string;
  productionStatusCode: string;
  isFirstCommit: boolean;
  disableCommitButton: boolean;
  isCommitOrUncommit: boolean;
}

export interface GetPriorProductionListRequestParam {
  pageNumber?: number;
  pageSize?: number;
  securityGroupId: number;
  reProductionId: number;
  sortColumn?: string;
  sortDirection?: string;
  productionSetId: number;
}

export interface SavePriorProductionToReProduceRequestParam {
  reProductionId: number;
  securityGroupId: number;
  priorProductionId: number;
  isMarkComplete: boolean;
}

export interface GetPriorProductionListResponse {
  priorProductionsDetails: IPriorProductionDetails[];
  totalRecords: number;
}

export interface SavePriorProductionToReProduceResponse {
  message: string;
}

export interface ReProductionDocumentsCountSelectionRequest {
  contextType: 'TAGS' | 'FOLDERS' | 'SAVEDSEARCH';
  contextIDs: number[];
}

export interface ReProductionDocumentsCountRequest {
  securityGroupId: number;
  isMarkComplete: boolean;
  reProductionSetId?: number;

  reProductionDocumentsSelectionRequest: ReProductionDocumentsCountSelectionRequest;
}

export interface ReProductionDocumentsCountResponse {
  totalDocs: number;
  docsWithoutBates: number;
  docsInMultipleProductions: number;
}

export interface IPriorProductionDetails {
  priorProductionId: number;
  priorProductionName: string;
  priorProductionDocCount: number;
  priorProductionBatesRange: string;
  reProductionDocCount: number;
  isSelected: boolean;
}
export interface GetReProductionGenerateViewRequestParam {
  SecurityGroupId: number;
  moduletype: string;
  reProductionId: number;
}

export interface ReProductionGenerateDetails {
  moduleType: string;
  reProductionId: number;
  isMarkComplete: boolean;
  reProductionName: string;
  priorProductionName: string;
  productionGenerateStatus: string;
  securityGroupIdForProduction: number;
  automatedCheckStep1Name: string;
  automatedCheckStep1Status: string;
  automatedCheckStep1ClassName: string;
  automatedCheckStep2Name: string;
  automatedCheckStep2Status: string;
  automatedCheckStep2ClassName: string;
  automatedCheckStep3Name: string;
  automatedCheckStep3Status: string;
  automatedCheckStep3ClassName: string;
  automatedCheckStep4Name: string;
  automatedCheckStep4Status: string;
  automatedCheckStep4ClassName: string;
  automatedCheckStep5Name: string;
  automatedCheckStep5Status: string;
  automatedCheckStep5ClassName: string;
  automatedCheckStep6Name: string;
  automatedCheckStep6Status: string;
  automatedCheckStep6ClassName: string;
  automatedCheckStep7Name: string;
  automatedCheckStep7Status: string;
  automatedCheckStep7ClassName: string;
  isSortByCustom: boolean;
  exportName: string | null;
  shouldContinue: boolean;
  canRegenerate: boolean;
  canGenerate: boolean;
  isAdd: string;
  productionStateCode: string;
  productionStatusCode1: string;
  productionType: number;
  productionStatusCode: number;
  regenerateType: number;
  productionTempararyFolderPath: string;
  productionDestinationFolderPath: string;
  productionFolderPath: string;
  shouldPerformBlankPageDetection: boolean;
  generatedBatesRange: string;
  totalDocCount: number;
  completedDocCount: number;
  docsCompleteStatus: string;
  canContinueWithPlacholdering: boolean;
  nativelyGeneratedDocs: number;
}
export interface GetReProductionGenerateViewResponse {
  reProductionGenerateDetails: ReProductionGenerateDetails;
  moduleTypeLabel: string;
  reProductionGeneratePollingInterval: number;
}
export interface getReProductionGenerateStatusParams {
  SecurityGroupId: number;
  moduletype: string;
  reProductionId: number;
}
export interface ReProductionCurrentStatus {
  reProductionStatusText: string;
  reProducitonDocsComplete: string;
  reProductionState: string;
  shouldContinue: boolean;
  reProductionStatusCode: number;
  reProductionStatus: string;
  isMarkComplete: boolean;
  generatedBatesRange: string;
  totalDocCount: number;
  completedDocCount: number;
}

export interface GetReProductionGenerateStatusResponse {
  reProductionCurrentStatus: ReProductionCurrentStatus;
}
export interface GetReProductionExportBatesRangeRequestParam {
  reProductionId: number;
}

export interface GetReProductionExecuteGenerateRequestBody {
  reProductionId: number;
  moduleType: string;
  isMarkComplete: boolean;
  shouldContinue: boolean;
  canGenerate: boolean;
  canRegenerate: boolean;
  securityGroupIdForProduction: number;
  productionType: number;
  productionStateCode: string;
  productionTempararyFolderPath: string;
  productionDestinationFolderPath: string;
  productionFolderPath: string;
  shouldPerformBlankPageDetection: boolean;
  regenerateType: number;
}

export type GetReProductionExecutePlaceholderingRequestBody =
  GetReProductionExecuteGenerateRequestBody;
